import Reflux from "reflux";
export const DumpActions = {
  get: Reflux.createAction()
};
